import { AppUrlOpen, Capacitor } from "@capacitor/core";
import { isProduction } from "lib/env";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { tryHandlersInOrder } from "../helpers";
import {
  handleBranchDeepLink,
  handleBranchPreviewUrl,
  handleSchemePath,
} from "./handlers";

const handleRuntimeAppUrlOpen = async (
  isBehindAuthGate: boolean,
  data: AppUrlOpen
) => {
  const handled = await tryHandlersInOrder(
    [
      ...(isBehindAuthGate ? [] : [handleSchemePath]),
      // In development builds allow the app to run on Vercel branch previews
      ...(isProduction() ? [] : [handleBranchPreviewUrl]),
    ],
    data.url
  );

  if (!handled && !isProduction()) {
    console.warn("appUrlOpen event unhandled:", data);
  }
};

const listenToBranch = () => {
  if (!Capacitor.isPluginAvailable("BranchDeepLinks")) {
    return null;
  }
  return Capacitor.Plugins.BranchDeepLinks.addListener(
    "init",
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    handleBranchDeepLink
  );
};

/**
 * Handles scheme links (penfold://) and branch deep links at runtime
 */
export const useAppUrlOpen = () => {
  const { pathname } = useRouter();
  const isBehindAuthGate =
    pathname.startsWith("/app") || pathname.startsWith("/auth");

  useEffect(() => {
    const appListener = Capacitor.Plugins.App.addListener(
      "appUrlOpen",
      (data) => void handleRuntimeAppUrlOpen(isBehindAuthGate, data)
    );
    const branchListener = listenToBranch();

    return () => {
      appListener.remove();
      branchListener?.remove();
    };
  }, [isBehindAuthGate]);
};
